import { cn } from "@/utils/styles";
import { SavedInConfigMarker } from "@/components/ClustersPage/SavedDeploymentConfigs/SavedInConfigMarker";

type SectionHeaderProps = {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  cta?: React.ReactNode;
  className?: string;
  /** When true, shows a bookmark marker — field is included in saved deployment configs. */
  savedInConfig?: boolean;
};

export const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  cta,
  className,
  savedInConfig = false
}) => (
  <div className={cn("flex items-end justify-between", className)}>
    <div className="flex flex-col gap-1">
      <h3 className="title-h5 flex flex-wrap items-center gap-2 text-foreground">
        {title}
        {savedInConfig ? <SavedInConfigMarker /> : null}
      </h3>
      <p className="subtext-small text-muted-foreground">{subtitle}</p>
    </div>
    {cta}
  </div>
);
